import { render, staticRenderFns } from "./bolsaValores.vue?vue&type=template&id=0ba3ac98&"
import script from "./bolsaValores.vue?vue&type=script&lang=js&"
export * from "./bolsaValores.vue?vue&type=script&lang=js&"
import style0 from "./bolsaValores.vue?vue&type=style&index=0&id=0ba3ac98&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports